import { constants } from "@newsela/angelou";

const uiColors = constants.colors.ui;

export const buttonRowCss = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "16px",
};

export const buttonMarginCss = {
  marginLeft: "8px",
};

export const inlineButtonRowCss = {
  display: "flex",
  marginLeft: "auto",
  alignItems: "center",

  div: {
    marginRight: "12px",
  },

  button: {
    color: uiColors.core[700],
  },
};

export const disabledButtonCss = (isCommentEditMode, isActionPending) => ({
  ...buttonMarginCss,
  opacity: isCommentEditMode && isActionPending ? ".4" : "1",
});
